import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionModalidadCiclicaByID = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionModalidadCiclicaByID = () => {
  const [loadingGetPrestacionModalidadCiclicaByID, setLoadingPrestacionModalidadCiclicaByID] = useState(false);
  const [successGetPrestacionModalidadCiclicaByID, setSuccessPrestacionModalidadCiclicaByID] = useState(false);
  const [errorGetPrestacionModalidadCiclicaByID, setErrorPrestacionModalidadCiclicaByID] = useState<any>(null);
  const [dataGetPrestacionModalidadCiclicaByID, setDataPrestacionModalidadCiclica] = useState<any>(null);

  const [statusGetPrestacionModalidadCiclicaByID, setStatusGetPrestacionModalidadCiclicaByID] =
    useState<StatusGetPrestacionModalidadCiclicaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionModalidadCiclicaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingPrestacionModalidadCiclicaByID(true);
    setSuccessPrestacionModalidadCiclicaByID(false);
    setErrorPrestacionModalidadCiclicaByID(null);

    try {
      const res = await apiRecord.getSolicitudModalidadCiclicaByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetPrestacionModalidadCiclicaByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessPrestacionModalidadCiclicaByID(true);
      setDataPrestacionModalidadCiclica(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionModalidadCiclicaByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorPrestacionModalidadCiclicaByID(err);
      console.error("Error en getPrestacionModalidadCiclicaByID:", err);

      throw err;

    } finally {
      setLoadingPrestacionModalidadCiclicaByID(false);
    }
  };

  return {
    getPrestacionModalidadCiclicaByID,
    loadingGetPrestacionModalidadCiclicaByID,
    successGetPrestacionModalidadCiclicaByID,
    errorGetPrestacionModalidadCiclicaByID,
    dataGetPrestacionModalidadCiclicaByID,
    statusGetPrestacionModalidadCiclicaByID
  };
};

export default useGetPrestacionModalidadCiclicaByID;
